import { submitAnalytics } from "../config/service";
import { getDeviceInfo } from "../utils/function";
import {
  getOrCreateSessionUUID,
  clearSessionUUID,
} from "../utils/sessionUUID";

const ANALYTICS_KEY = "meeting_request_event_id";
const ANALYTICS_ONLY_FOR_UTM = true;

const isMeetingRequestPage = () =>
  window.location.pathname.includes("meetingrequest");


const getCurrentUrl = () =>
  window.location.pathname + window.location.search;

const hasUtmParam = () => {
  const params = new URLSearchParams(window.location.search);
  return params.has("utm");
};

const sendEvent = async (data) => {
  if (!isMeetingRequestPage()) return;
  if (ANALYTICS_ONLY_FOR_UTM && !hasUtmParam()) return;

  const { os, browser } = getDeviceInfo();

  const payload = {
    eventId: getOrCreateSessionUUID(ANALYTICS_KEY),
    url: getCurrentUrl(),
    timestamp: Date.now(),
    os,
    browser,
    ...data,
  };

  try {
    await submitAnalytics(payload)
  } catch (error) {
    console.error("Analytics error:", error);
  }
};

export const trackUrlOpened = () =>
  sendEvent({ eventType: "urlOpened" });

export const trackStepOpened = (eventType, stepNumber) =>
  sendEvent({
    eventType,
    stepNumber,
  });

export const trackFullSubmit = (meetingId) => {
  sendEvent({
    eventType: "full form was submitted",
    meetingId,
  });

  clearSessionUUID(ANALYTICS_KEY);
};